import Footer from "@/base/Footer";
import { UnlockOrPreviewContentBannerForViewVeiledBottom } from "@/components/UnlockOrPreviewContentBanner";
import { LANG_EN } from "@/constants/Language";
import { Article, LangstonContentResponse } from "@/types/models";
import ContentLevel from "@/types/models/ContentLevel.interface";
import ArticleDisplay from "@/view/ContentDisplay/ArticleDisplay";
import { articleHasHeaderImage } from "@/view/ContentDisplay/ContentDisplayHeaderMedia/ContentDisplayHeaderMedia.utils";
import ContentHead, { Metadata } from "@/view/ContentHead";
import ContentHeader from "@/view/ContentHeader";
import ContentLayout from "@/view/ContentLayout";
import { UserContentUIContextProvider } from "@/view/utils/useUserContentUIContext";

interface UnauthViewPageContentProps {
  content: LangstonContentResponse | null | undefined;
  contentMetadata: Metadata | undefined | null;
  isLevelledContent: boolean;
}

const UnauthViewPageContent = ({
  content,
  contentMetadata,
  isLevelledContent,
}: UnauthViewPageContentProps) => {
  if (!content) return null;

  let currentLevel;
  if (isLevelledContent) {
    const articleLevels = (content.data as Article)
      .article_levels as ContentLevel[];
    currentLevel =
      articleLevels.find(({ language }) => language === LANG_EN) ||
      articleLevels[0];
  }

  const hasHeaderImage = articleHasHeaderImage(content?.data);
  const imageUrl = hasHeaderImage
    ? (content.data as Article).header_image.url
    : undefined;
  const isAllowedInSearch = contentMetadata?.data?.allowed_in_search ?? true;

  return (
    <UserContentUIContextProvider>
      <ContentHead
        title={currentLevel?.title}
        teaser={currentLevel?.teaser}
        imageUrl={imageUrl}
        isAllowedInSearch={isAllowedInSearch}
      />
      <ContentLayout.UnauthLayout>
        <ContentLayout.Header>
          <ContentHeader.Unauth currentLevel={currentLevel} />
        </ContentLayout.Header>
        <ContentLayout.UnauthMainSection hasHeaderImage={hasHeaderImage}>
          <ArticleDisplay.Unauth
            content={content}
            currentLevel={currentLevel}
          />
          <UnlockOrPreviewContentBannerForViewVeiledBottom
            isPremiumContent={content?.data?.is_premium}
            isVideo={false}
          />
        </ContentLayout.UnauthMainSection>
        <ContentLayout.PageBottom>
          <Footer />
        </ContentLayout.PageBottom>
      </ContentLayout.UnauthLayout>
    </UserContentUIContextProvider>
  );
};

export default UnauthViewPageContent;
